<template>
  <div class="auth_back">
    <div class="auth">
<!--      <div class="logo">-->
<!--        <a href="#" class="simple-text">-->
<!--          <div class="logo-img">-->
<!--            <img src="/web/img/logo.png" alt="logo">-->
<!--          </div>-->
<!--          {{$root.attribute.name_company}} Monitoring-->
<!--        </a>-->
<!--      </div>-->
      <div class="content">
        <div class="col-md-12">
          <fg-input
            v-model="name"
            type="text"
            label="Username"
            autocomplete="on"
            :error="error"
            placeholder="Username"
          />
        </div>
        <div class="col-md-12">
          <fg-input
            v-model="pass"
            type="password"
            label="Password"
            autocomplete="on"
            placeholder="Password"
          />
        </div>
        <div class="auth_button">
          <button class="btn btn-info btn-fill btn-wd" @click = "auth">
            Sign in
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data () {
    return {
      name: '',
      pass: '',
      error: false
    }
  },
  created() {
    document.addEventListener('keyup', (evt) => {
      if (this.$route.name === 'auth' && evt.key === 'Enter') {
        this.auth()
      }
    });
  },
  mounted () {
    if (this.$store.getters.getAuth === true) {
      this.$router.push('/')
    }
  },
  methods: {
    auth () {
      this.$http.v1.loginUser({username: this.name, password: this.pass},(response) => {
        if (response.data.token !== undefined) {

          this.$http.v1.addHeader({'Auth': response.data.token})

          this.localStorage.setItem('auth', response.data.token)
          this.localStorage.setItem('logout', '0')

          this.$store.commit('updateAuth', true)

          this.getStatusUser()
        }
      },
      (bad_answer) => {
        this.name = ''
        this.pass = ''
        this.bad_answer_handler(bad_answer)
      })
    },
    getStatusUser () {
      if (this.localStorage.getItem('auth') !== null) {
        this.$http.v1.getUserStatus((resp) => {
          this.$store.commit('updateAuth', true)
          this.$store.commit('updateUser', resp.data.user)

          if (resp.data.props){
            this.$root.attribute.name_company = resp.data.props.company;
            this.$root.attribute.company_url =  resp.data.props.company_url;
            this.$root.attribute.logo_url =  resp.data.props.custom_logo;
          }

          this.$store.commit('setGlobalTiming', resp.data.front_timers)
          this.$store.commit('updateModules', resp.data.monitoring_modules)
          this.$store.commit('updateSettings', resp.data.settings)

          this.$store.commit('WsSetAuth', this.localStorage.getItem('auth'))
          this.$store.dispatch("WSConnect",resp.data.servicebridge_url)
        }, () => {
          this.localStorage.removeItem('auth')
          this.$store.commit('updateAuth', false)
        })
      } else {
        this.$store.commit('updateAuth', false)
      }
    }
  }
}
</script>
<style>

  .auth_back {
    width: 100%;
    height: 100%;
    position: absolute;
    background-color: #f4f3ef;
  }

</style>
